const base = {
  state: {
    uid: null,
    test: null,
    verifyCodeImg: null,
  },
  mutations: {
    logout (state) {
      state.token = null
      window.localStorage.removeItem('token')
    },
    saveBaseData (state, data) {
      window.localStorage.setItem('role', data.role)
      window.localStorage.setItem('email', data.email)
      window.localStorage.setItem('userID', data.userID)
      window.localStorage.setItem('token', data.token)
      window.localStorage.setItem('clientID', data.clientID)
      window.localStorage.setItem('username', data.username)
      window.localStorage.setItem('nickname', data.nickname)
      window.localStorage.setItem('avatarUrl', data.avatarUrl)
      window.localStorage.setItem('teachRole', data.teachRole)
      window.localStorage.setItem('contestFalg', data.contestFalg)
      window.localStorage.setItem('courseFalg', data.courseFalg)
      window.localStorage.setItem('organizationID', data.orgID)
    },

    // KV
    saveKVCmOptions (state, data) {
      window.localStorage.setItem('theme', data.theme)
      window.localStorage.setItem('fontSize', data.fontSize)
      window.localStorage.setItem('tabSize', data.tabSize)
    },
    saveKVojCode (state, data) {
      window.localStorage.setItem('ojCode', data)
    },
    saveKVshowAll (state, data) {
      window.localStorage.setItem('showAll', data)
    },

    saveOrganizationData (state, data) {
      window.localStorage.setItem('logo', data.logo)
      window.localStorage.setItem('organizationName', data.organizationName)
      window.localStorage.setItem('organizationID', data.id)
    },
    saveOrganizationName (state, data) {
      window.localStorage.setItem('organizationName', data)
    },
    saveXiaoXiong (state, data) {
      window.localStorage.setItem('xiaoxiong', data)
    },
    saveClassid (state, data) {
      window.localStorage.setItem('classid', data)
    },
    saveXiaoXiongUrl (state, data) {
      window.localStorage.setItem('xiaoxiongUrl', data)
    },
    saveClass (state, data) {
      window.localStorage.setItem('class', data)
    },
    saveCodeLanguage (state, data) {
      window.localStorage.setItem('codeLanguage', data)
    },
    saveSidebarFlag (state, data) {
      window.localStorage.setItem('sidebarFlag', data)
    },
    saveAltTabNum (state, data) {
      window.localStorage.setItem('altTabNum', data)
    },
    saveContestSplitFlag (state, data) {
      window.localStorage.setItem('contestSplitFlag', data)
    },
    saveCourseSplitFlag (state, data) {
      window.localStorage.setItem('courseSplitFlag', data)
    },
    saveCountdown (state, data) {
      window.localStorage.setItem('countdown', data)
    },
    saveAvatarUrl (state, data) {
      window.localStorage.setItem('avatarUrl', data)
    },
    saveSubjectType (state, data) {
      window.localStorage.setItem('subjectType', data)
    },
    saveNickname (state, data) {
      window.localStorage.setItem('nickname', data)
    }
  }
}

export default base